module.exports = __webpack_public_path__ + "static/media/dk.302b4687.svg";